import React, { useState, useEffect } from "react";
import { useEventEntriesScoreboardByDivId } from "../util/db";
import Spinner from "react-bootstrap/Spinner";
import FormAlert from "./FormAlert";
import ScorecardSummaryTableStickyHeader from "./ScorecardSummaryTableStickyHeader";
import DisplayScoreboardByDivisionTable from "./DisplayScoreboardByDivisionTable";

function ScoreboardDivisionSection({
  division,
  index,
  throwScoringModeId,
  eventId,
}) {
  const [numHoles, setNumHoles] = useState(20);

  // Get scorecard for this specific division
  const {
    data: scoreBoard,
    status: scoreBoardStatus,
    // error: scoreBoardError,
  } = useEventEntriesScoreboardByDivId(eventId, division[0]);

  useEffect(() => {
    if (scoreBoard && scoreBoard.length > 0) {
      const maxHoles = Math.max(
        ...scoreBoard.map((entry) => entry.hole_scores.length || 0)
      );
      setNumHoles(maxHoles);
    }
  }, [scoreBoard]);
  if (scoreBoardStatus === "loading") {
    return (
      <div className="py-3 px-3 align-self-center">
        <h1>
          <Spinner animation="border" size="sm" variant="primary" />
          <span className="ms-2">{division[1]}</span>
        </h1>
      </div>
    );
  }

  if (scoreBoardStatus === "error") {
    return (
      <div className="py-3 px-3 align-self-center">
        <FormAlert type="error" message={`Error loading ${division[1]}`} />
      </div>
    );
  }

  if (
    scoreBoardStatus === "success" &&
    (!scoreBoard || scoreBoard.length === 0)
  ) {
    return (
      <div className="py-3 px-3 align-self-center">
        <h1>{division[1]}</h1>
        <p>No players in this division yet.</p>
      </div>
    );
  }

  return (
    <React.Fragment key={index}>
      <h1>{division[1]}</h1>
      <div className="table-wrapper">
        <table>
          <thead>
            <ScorecardSummaryTableStickyHeader
              // onJumpToHole={onJumpToHole}
              maxHole={numHoles}
              throwScoringModeId={throwScoringModeId}
            />
          </thead>
          <tbody>
            <DisplayScoreboardByDivisionTable
              eventId={eventId}
              scoreBoard={scoreBoard}
              numHoles={numHoles}
              divisionId={division[0]}
              throwScoringModeId={throwScoringModeId}
            />
          </tbody>
        </table>
      </div>
    </React.Fragment>
  );
}

export default ScoreboardDivisionSection;
